const text = require('./text');

module.exports = {
	...text,
	name: 'textbox'
};
